import { Component, forwardRef, HostBinding, Input } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { iValidatedControl } from '../iValidatedControl';
import { BaseCustomControl } from '../baseCustomControl';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.html',
  standalone: false,
  providers: [
    // see https://blog.thoughtram.io/angular/2016/07/27/custom-form-controls-in-angular-2.html
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => Checkbox),
      multi: true,
    },
  ],
})
export class Checkbox extends BaseCustomControl  implements ControlValueAccessor, iValidatedControl {

  @HostBinding('class.formField') formFieldClass = true; // Always applied
  @HostBinding('class.readOnly') get isReadOnly() {
    return this.readonly;
  }

  override ngOnInit(): void {
    super.ngOnInit();

    if ((!this.validationMsg || this.validationMsg == "") && this.required) {
      this.validationMsg = "Required";
    }
  }

  override clear() {
    this.boundValue = "";
    this.actualValue = "";
  }

  
  // This writes the boundValue back to the Angular model
  handle_change(e:any):void {
      this.onChange(this.boundValue);

      if (this.onChanged) {
        this.onChanged.emit(this.boundValue);
      };
  }  

  public validate():boolean {
    return true;
  }


}
